import {ISerializable} from "../../typescript-plugin/entities/ISerializable";

export class FileUploadMetadata implements ISerializable{

    public name:string;
    public type:string;
    public uploadUrl:string;

    public Deserialize(data: {}): void {
        this.name = data["name"];
        this.type = data["type"];
        this.uploadUrl = data["uploadUrl"];
    }

    public Serialize(): {} {
        return {
            name: this.name,
            type: this.type,
            uploadUrl: this.uploadUrl
        }
    }

    public ToString():string{
        return this.name + " with format " + this.type + " to " + this.uploadUrl;
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/server/src/base/entities/FileUploadMetadata.ts